import { render, staticRenderFns } from "./myPublish.vue?vue&type=template&id=270d1009&scoped=true&"
import script from "./myPublish.vue?vue&type=script&lang=js&"
export * from "./myPublish.vue?vue&type=script&lang=js&"
import style0 from "./myPublish.vue?vue&type=style&index=0&id=270d1009&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270d1009",
  null
  
)

export default component.exports